// permissions/findFirstAccessibleRoute.js
import { getPermission } from "./rolePermissions";
import { WEB_ROUTES } from "./webRoutes";

export function findFirstAccessibleRoute(role) {
  for (const route of WEB_ROUTES) {
    const perm = getPermission(role, route.capability);
    if (perm === "view" || perm === "edit") {
      return route.path;
    }
  }
  return "/login"; // or "/no-access"
}
